export default __webpack_public_path__ + "static/media/1482.989f223b.png";